export default __webpack_public_path__ + "static/media/GF_POSTER_GROUP_03.59fa12b0.jpg";